// MobileMenu.js
import React from "react";
import { useNavigate } from "react-router-dom";
import { CloseOutlined } from "@ant-design/icons";
import './MobileMenu.css';
import { message } from "antd";

function MobileMenu({ isOpen, onClose, isLoggedIn, setLoggedIn, setProfileImage }) {
  const navigate = useNavigate();

  const handleSignOut = () => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userInfo");
    localStorage.removeItem("userPhoto");
    
    setLoggedIn(false);
    if (setProfileImage) setProfileImage(null);
    
    navigate("/");
    onClose();
    
    message.success("You have been signed out successfully");
  };

  const courses = [
    'English', 'Science', 'Chemistry', 'Physics', 'Mathematics', 'Book Keeping',
    'Commerce', 'Biology', 'Arts', 'Geography', 'Civics', 'Kiswahili', 'History', 'Literature',
  ];

  const loggedInUserOptions = [
    { label: 'My classes', route: '/user-classes' },
    { label: 'View Profile', route: '/user-profile' },
    { label: 'Account Settings', route: '/account-settings' },
    { label: 'Exams', route: '/exam-system' },
    { label: 'Refer a friend', route: null, onClick: () => console.log("Refer a friend clicked") },
    { label: 'Help', route: '/faq' },
    { 
      label: 'Sign Out', 
      route: null, 
      onClick: handleSignOut,
      className: 'sign-out-item' // Added special class for sign out
    },
  ];

  const loggedOutUserOptions = [
    { label: 'Sign In', route: '/signin' },
    { label: 'Create Account', route: '/signUp' },
  ];

  const handleNavigateToCourses = () => {
    navigate("/courses");
    onClose();
  };

  const handleNavigateToExams = () => navigate("/exam-system")


  return (
    <div className={`mobile-menu ${isOpen ? "open" : ""}`}>
      <div className="mobile-menu-header">
        <CloseOutlined className="close-icon" onClick={onClose} />
      </div>
      <div className="mobile-menu-content">
        {/* User Info section moved to top */}
        <div className="mobile-menu-section user-info-section">
          <h3>Account</h3>
          {(isLoggedIn ? loggedInUserOptions : loggedOutUserOptions).map((option, index) => (
            <div
              key={index}
              className={`menu-item ${option.className || ''} ${
                option.label === 'Sign In' || option.label === 'Create Account' ? 'auth-item' : ''
              }`}
              onClick={() => {
                if (option.onClick) option.onClick();
                if (option.route) navigate(option.route);
                onClose();
              }}
            >
              {option.label}
            </div>
          ))}
        </div>
        
        <div className="mobile-menu-section">
          <h3>Classes</h3>
          <div className="courses-grid">
            {courses.map((course, index) => (
              <div key={index} className="course-item" onClick={handleNavigateToCourses}>
                {course}
              </div>
            ))}
          </div>
        </div>
        
        <div className="mobile-menu-section">
          <h3>Sessions</h3>
          <div className="menu-item" onClick={() => navigate("/session")}>
            Explore Sessions
          </div>
        </div>
      </div>
    </div>
  );
}

export default MobileMenu;